import { useCallback } from 'react';
import useSnackbarSystem from '@ui/systems/useSnackbarSystem';
import useReduxPopupSystem from 'src/new_arch/hooks/useReduxPopupSystem';

import ProjectInvitation from '../../models/projectInvitation';
import useDeleteProjectInvitationMutation from '../../queries/useDeleteProjectInvitationMutation';

type UseProjectInvitationActionsProps = {
	projectID: number;
};

const useProjectInvitationActions = ( { projectID }: UseProjectInvitationActionsProps ) => {
	const snackbarSystem = useSnackbarSystem();
	const popupSystem = useReduxPopupSystem();

	const { mutate: deleteProjectInvitation } = useDeleteProjectInvitationMutation( {
		projectID,
		onSuccess: invitation => (
			snackbarSystem.showSuccessMessage( {
				title: 'Invitation deleted',
				description: `The invitation to ${invitation.email} has been removed from the project`
			} )
		),
		onError: () => snackbarSystem.showErrorMessage( { title: 'Error deleting invitation' } )
	} );

	const onDeleteProjectInvitation = useCallback( ( invitation: ProjectInvitation ) => {
		popupSystem.showDefaultConfirmationDialog( {
			title: 'Are you sure you want to delete this invitation?',
			description: `Are you sure you want to delete the invitation to <strong>${invitation.email}</strong> from the project?`,
			acceptText: 'Delete',
			cancelText: 'Cancel',
			descriptionAlignment: 'left',
			acceptButtonColor: 'danger'
		} )
			.then( ( confirm: boolean ) => {
				popupSystem.hideConfirmationDialog();
				if ( confirm ) deleteProjectInvitation( invitation );
			} );
	}, [ deleteProjectInvitation ] );

	return {
		onDeleteProjectInvitation
	};
};

export default useProjectInvitationActions;
